/**
 * Public API source adapters
 *
 * Browser-direct fetches for the heavy 3-year time-series that drive the
 * price/hashrate and fees charts. Output is shaped to match Sidewinder so
 * downstream consumers (data.ts04.hashrate.hashrates, data.ts08.mining_fees,
 * data.ts15.price.values) work without modification.
 *
 * Why direct: distributes load across user IPs (vs Sidewinder's single IP),
 * and these endpoints are 2-5x faster than Sidewinder which proxies them anyway.
 * CORS verified open on both origins.
 */

const MEMPOOL_BASE = 'https://mempool.space/api';
const BLOCKCHAIN_INFO_BASE = 'https://api.blockchain.info';

const fetchJson = async (url, timeoutMs = 6000) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(url, {
      signal: controller.signal,
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    return await response.json();
  } finally {
    clearTimeout(timer);
  }
};

// ts04 — Sidewinder shape: { hashrate: { hashrates, difficulty, currentHashrate, currentDifficulty } }
export const fetchHashrate = async () => {
  const data = await fetchJson(`${MEMPOOL_BASE}/v1/mining/hashrate/3y`);
  return { hashrate: data };
};

// ts08 — Sidewinder shape: { mining_fees: [...] }
export const fetchMiningFees = async () => {
  const data = await fetchJson(`${MEMPOOL_BASE}/v1/mining/blocks/fees/3y`);
  return { mining_fees: data };
};

// ts15 — Sidewinder shape: { price: { name, unit, period, status, values } }
export const fetchPrice = async () => {
  const data = await fetchJson(
    `${BLOCKCHAIN_INFO_BASE}/charts/market-price?timespan=3years&format=json&cors=true`
  );
  return { price: data };
};
